import { Box, Text } from "@chakra-ui/react";

const FiftyPercent = () => {
  return (
    <Box h="100vh" w="100%" bg="green.400" p={5}>
      <Text textAlign={"center"}>FiftyPercent</Text>
    </Box>
  );
};

export default FiftyPercent;
